// extracted by mini-css-extract-plugin
export default {"cars_wrapper":"SectionCars_cars_wrapper__Y9MsA","cars":"SectionCars_cars__MqiPz","car_img":"SectionCars_car_img__YABBW","car_name":"SectionCars_car_name__Rg7-j"};